import classNames from 'classnames'
import Button from '@dustin-web/microsite-components/src/button'
import { useSiteContext, useTranslations } from '@dustin-web/microsite-components/src/hooks'
import { CartItemFragment } from '@dustin-web/microsite-data/src/graphql/product/generated/graphql-types'
import { ProductDigitalData } from '@dustin-web/product-components/src/utils/product-digital-data'
import Icon from '@dustin-web/microsite-components/src/icon'

type Props = {
  className?: string
  cartItems: CartItemFragment[]
}

export const CartDrawer = ({ className, cartItems }: Props) => {
  const { translate } = useTranslations()
  const { siteUrl } = useSiteContext()

  return (
    <>
      <div className={classNames('u-pb-16 d-flex flex-column u-h-100', className)}>
        <div>
          <div className="d-flex u-bb u-px-16 u-py-16 u-px-sm-24 u-py-sm-24 u-ml-0">
            <Icon name="shopping-cart-5" className="u-mr-16 i-24" />
            <h1 className="h2 u-fs-20 u-pt-4 u-mb-0">{translate('Cart_Drawer_Header')}</h1>
          </div>
          <div className="u-px-16 u-pb-16 u-pt-24 u-px-sm-24 u-pb-sm-24">
            <h3 className="u-pl-8 u-fs-14">
              {translate('Cart_LoginBox_USP_Header')}
            </h3>
            <ul className="u-pl-40 u-mb-0 u-py-0">
              <li className="u-fs-14 u-mb-0">
                {translate('Cart_LoginBox_USP_Body1')}
              </li>
              <li className="u-fs-14 u-mb-0">
                {translate('Cart_LoginBox_USP_Body2')}
              </li>
              <li className="u-fs-14">
                {translate('Cart_LoginBox_USP_Body3')}
              </li>
            </ul>
          </div>
        </div>
        <div className="d-flex flex-column u-px-16 u-px-sm-24 u-pt-16">
          <Button
            primary
            link
            onClick={() =>
              ProductDigitalData.pushEventWithCartItems('b2b_begin_login', cartItems)
            }
            href="/login?returnUrl=checkoutflow"
            text={translate('Cart_Login')}
            id="cart-login-box--login-button"
            className="c-btn--checkout c-btn--block c-btn-md--contain c-btn-xl--block u-mb-16"
          />
          <Button
            primary
            link
            onClick={() =>
              ProductDigitalData.pushEventWithCartItems('b2b_begin_register', cartItems)
            }
            href={`/registration?returnUrl=${siteUrl}/checkoutflow`}
            text={translate('Cart_CreateAccount')}
            id="cart-login-box--register-button"
            className="c-btn--block c-btn-md--contain c-btn-xl--block u-mb-8"
          />
          <div className="d-flex justify-content-center align-items-center u-mb-8">
            <div
              className="u-bg-light-gray u-radius-4 u-w-100 u-mr-8"
              style={{ height: '1px' }}></div>

            <p className="u-fs-14 u-pt-4 u-mr-8">{translate('HelpToFindContent_Or')}</p>
            <div className="u-bg-light-gray u-radius-4 u-w-100" style={{ height: '1px' }}></div>
          </div>
          <Button
            link
            onClick={() =>
              ProductDigitalData.pushEventWithCartItems('b2b_begin_guestcheckout', cartItems)
            }
            href={'/checkoutsite/noaccount'}
            text={translate('Cart_NoAccount2')}
            id="cart-login-box--noaccount-button"
            className="c-btn--block c-btn-md--contain c-btn-xl--block u-mb-16 u-mr-sm-16 u-mr-xl-0"
          />
          <p className="u-fs-14">
            {translate('Cart_Drawer_Disclaimer')}
          </p>
        </div>
      </div>
    </>
  )
}
